const ComponentsLookup = {
  "default-footer": "DefaultFooter956a8f82F7774914Ac1d403c9d988ec8"
}

export default ComponentsLookup;